<template>
  <div id="app" class="min-h-screen bg-gray-50 dark:bg-background">
    <HeaderNav v-if="showHeader" />

    <main :class="{ 'pt-0': isAuthPage }">
      <router-view :key="$route.fullPath" />
    </main>

    <Toast />
  </div>
</template>

<script>
import HeaderNav from "@/components/HeaderNav.vue";
import Toast from "@/components/Toast.vue";

export default {
  name: "App",
  components: {
    HeaderNav,
    Toast,
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isAuthPage() {
      const authPages = ["Login", "SignUp", "ForgotPassword", "ResetPassword"];
      return authPages.includes(this.$route.name);
    },
    showHeader() {
      return (
        this.isAuthenticated &&
        !this.isAuthPage &&
        this.$route.name !== "LockInMode"
      );
    },
  },
};
</script>

<style>
@import "./assets/styles.css";
@import "tailwindcss/base";
@import "tailwindcss/components";
@import "tailwindcss/utilities";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
}
</style>
